import { createFileRoute } from '@tanstack/react-router'

import { OrderManagementPage } from '@/features/order-management/components/OrderManagementPage'
import { orderManagementSearchSchema } from '@/features/order-management/list-model'
import { orderListInfiniteQueryOptions } from '@/features/order-list/queries'
import { orderManagementFilters } from '@/features/order-management/list-model'

export const Route = createFileRoute('/_authed/order-management/')({
  validateSearch: orderManagementSearchSchema,
  shouldReload: ({ cause }) => cause !== 'stay',
  loader: async ({ context, location }) => {
    const search = orderManagementSearchSchema.parse(location.search)
    const filters = orderManagementFilters(search)
    await context.queryClient.prefetchInfiniteQuery(orderListInfiniteQueryOptions(filters))
  },
  component: OrderManagementRoute,
})

function OrderManagementRoute() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <OrderManagementPage
      search={search}
      onChange={(patch) => {
        void navigate({ search: { ...search, ...patch }, replace: true, resetScroll: false })
      }}
    />
  )
}
